import React, { useEffect, Children, createElement } from 'react';
import { motion } from 'framer-motion';
import { Check, Star, ShieldCheck, Download, Layout, FileText, Monitor, Users, Lock, Zap, MousePointerClick, Award, BookOpen, Calendar } from 'lucide-react';
import { CountdownTimer } from './components/CountdownTimer';
import { CTAButton } from './components/CTAButton';
import { SocialProofPopup } from './components/SocialProofPopup';
import { AccordionItem } from './components/Accordion';
// Images
const IMAGES = {
  product: 'https://cdn.magicpatterns.com/uploads/2Dv11jQTiKnFDktqejD6CW/imagen_ebook.png',
  bono1: 'https://cdn.magicpatterns.com/uploads/egSdXQngUdJRFCRVe1NVhf/Bono_1.png',
  bono2: 'https://cdn.magicpatterns.com/uploads/aGSSsK8zMWqxKYhKXmDSm5/bono_2.png',
  bono3: 'https://cdn.magicpatterns.com/uploads/6yWNYE9wDZgANN2NibC9a8/bono_3.png',
  bono4: 'https://cdn.magicpatterns.com/uploads/o3eZCAg9b9eh29AjDxR1qx/Bono_4.png'
};
export function App() {
  // Meta Pixel
  useEffect(() => {
    // @ts-ignore
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      // Fixed: Append directly to head instead of relying on existing script tags
      b.head.appendChild(t);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // @ts-ignore
    fbq('init', '3070568583125644');
    // @ts-ignore
    fbq('track', 'PageView');
  }, []);
  const fadeIn = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  const staggerContainer = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const scrollToPurchase = (e: React.MouseEvent) => {
    e.preventDefault();
    const purchaseSection = document.getElementById('purchase');
    if (purchaseSection) {
      purchaseSection.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <div className="font-sans text-slate-800 bg-slate-50 antialiased selection:bg-yellow-200 selection:text-slate-900 pt-10" data-id="element-0">
      <style data-id="element-1">{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Outfit:wght@500;700;800&display=swap');
        h1, h2, h3, h4, h5, h6 { font-family: 'Outfit', sans-serif; }
        body { font-family: 'Inter', sans-serif; }
      `}</style>

      <CountdownTimer data-id="element-2" />
      <SocialProofPopup data-id="element-3" />

      {/* HERO SECTION */}
      <section className="relative bg-gradient-to-b from-blue-600 to-blue-800 text-white pt-12 pb-20 px-4 overflow-hidden" data-id="element-4">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: 'radial-gradient(#fff 1px, transparent 1px)',
        backgroundSize: '20px 20px'
      }} data-id="element-5"></div>

        <div className="max-w-6xl mx-auto relative z-10" data-id="element-6">
          <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-7">
            <motion.div className="flex-1 text-center md:text-left" initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={fadeIn} data-id="element-8">
              <div className="inline-block bg-yellow-400 text-blue-900 font-bold px-4 py-1 rounded-full text-sm mb-6 shadow-lg transform -rotate-1" data-id="element-9">
                💻 MEGAPACK INFORMÁTICA LISTA™
              </div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6" data-id="element-10">
                ORGANIZÁ TODO TU AÑO DE{' '}
                <span className="text-yellow-400" data-id="element-11">INFORMÁTICA</span> SIN ESTRÉS
              </h1>
              <p className="text-xl text-blue-100 mb-8 leading-relaxed" data-id="element-12">
                Clases listas • Actividades • Proyectos • Evaluaciones •
                Rúbricas • Planificación anual. Todo tu año de Informática
                resuelto (Primaria + Secundaria).
              </p>

              <div className="flex flex-col gap-4 mb-8" data-id="element-13">
                {['Acceso inmediato y de por vida', 'Material listo para imprimir y usar', 'Garantía de satisfacción total'].map((item, i) => <div key={i} className="flex items-center gap-3 justify-center md:justify-start" data-id="element-14">
                    <div className="bg-green-500 rounded-full p-1" data-id="element-15">
                      <Check className="w-4 h-4 text-white" strokeWidth={3} data-id="element-16" />
                    </div>
                    <span className="font-medium" data-id="element-17">{item}</span>
                  </div>)}
              </div>

              <div className="flex justify-center md:justify-start" data-id="element-18">
                <CTAButton text="QUIERO ACCESO INMEDIATO" size="xl" scrollToSection={true} data-id="element-19" />
              </div>
            </motion.div>

            <motion.div className="flex-1 relative" initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.5
          }} data-id="element-20">
              <div className="absolute inset-0 bg-blue-500 blur-3xl opacity-30 rounded-full" data-id="element-21"></div>
              <a href="#purchase" onClick={scrollToPurchase} className="cursor-pointer" data-id="element-22">
                <img src={IMAGES.product} alt="MegaPack Informática Lista" className="relative z-10 w-full drop-shadow-2xl hover:scale-105 transition-transform duration-300 cursor-pointer" data-id="element-23" />
              </a>
            </motion.div>
          </div>
        </div>

        {/* Wave Divider */}
        <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none" data-id="element-24">
          <svg className="relative block w-[calc(100%+1.3px)] h-[50px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-25">
            <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="fill-slate-50" data-id="element-26"></path>
          </svg>
        </div>
      </section>

      {/* PAIN POINTS SECTION */}
      <section className="py-20 px-4 max-w-4xl mx-auto" data-id="element-27">
        <motion.div className="text-center mb-12" initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} data-id="element-28">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-29">
            Si enseñás Informática, esto te va a sonar demasiado familiar…
          </h2>
          <p className="text-lg text-slate-600" data-id="element-30">
            Llegás cansado/a. Sabés que tenés que planificar. Abrís la
            computadora… y otra vez empezás desde cero.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-31">
          <motion.div className="bg-white p-8 rounded-2xl shadow-lg border-l-4 border-red-500" initial={{
          x: -50,
          opacity: 0
        }} whileInView={{
          x: 0,
          opacity: 1
        }} viewport={{
          once: true
        }} data-id="element-32">
            <h3 className="text-xl font-bold text-red-600 mb-4 flex items-center gap-2" data-id="element-33">
              <Zap className="w-6 h-6" data-id="element-34" />
              El ciclo del agotamiento
            </h3>
            <ul className="space-y-4 text-slate-700" data-id="element-35">
              <li className="flex items-start gap-3" data-id="element-36">
                <span className="text-2xl" data-id="element-37">😫</span>
                <span data-id="element-38">"Hoy hago algo rápido…"</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-39">
                <span className="text-2xl" data-id="element-40">📅</span>
                <span data-id="element-41">"Después lo organizo…"</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-42">
                <span className="text-2xl" data-id="element-43">⏰</span>
                <span data-id="element-44">"No tengo tiempo…"</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-45">
                <span className="text-2xl" data-id="element-46">🔥</span>
                <span data-id="element-47">Informática convertida en apagar incendios.</span>
              </li>
            </ul>
          </motion.div>

          <div className="flex flex-col justify-center" data-id="element-48">
            <p className="text-lg text-slate-700 mb-6" data-id="element-49">
              El problema real{' '}
              <span className="font-bold text-blue-600" data-id="element-50">
                no es tu capacidad como docente
              </span>
              . No es porque no sepas enseñar. No es porque seas desordenado/a.
            </p>
            <p className="text-xl font-bold text-slate-900 bg-yellow-100 p-4 rounded-lg border border-yellow-300" data-id="element-51">
              Es porque estás intentando sostener todo el año… sin un sistema
              listo que te sostenga a vos.
            </p>
          </div>
        </div>
      </section>

      {/* SOLUTION SECTION */}
      <section className="py-20 bg-slate-900 text-white relative overflow-hidden" data-id="element-52">
        <div className="absolute inset-0 opacity-20" style={{
        backgroundImage: 'linear-gradient(45deg, #2563EB 25%, transparent 25%, transparent 50%, #2563EB 50%, #2563EB 75%, transparent 75%, transparent)',
        backgroundSize: '40px 40px'
      }} data-id="element-53"></div>

        <div className="max-w-6xl mx-auto px-4 relative z-10" data-id="element-54">
          <div className="text-center mb-16" data-id="element-55">
            <span className="text-yellow-400 font-bold tracking-wider uppercase text-sm" data-id="element-56">
              La solución definitiva
            </span>
            <h2 className="text-4xl md:text-6xl font-extrabold mt-2 mb-6" data-id="element-57">
              MEGAPACK INFORMÁTICA LISTA™
            </h2>
            <p className="text-xl md:text-2xl text-blue-200 max-w-3xl mx-auto" data-id="element-58">
              Un sistema anual completo de clases listas para usar. No es un PDF
              suelto. Es tu año resuelto.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12" data-id="element-59">
            {[{
            icon: Layout,
            text: 'Todo organizado'
          }, {
            icon: FileText,
            text: 'Todo imprimible'
          }, {
            icon: Check,
            text: 'Todo claro'
          }, {
            icon: Calendar,
            text: 'Todo reusable'
          }].map((item, i) => <motion.div key={i} className="bg-slate-800/50 backdrop-blur-sm border border-slate-700 p-6 rounded-xl text-center hover:bg-slate-700 transition-colors" whileHover={{
            y: -5
          }} data-id="element-60">
                <item.icon className="w-10 h-10 text-yellow-400 mx-auto mb-3" data-id="element-61" />
                <h3 className="font-bold text-lg" data-id="element-62">{item.text}</h3>
              </motion.div>)}
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-63">
            {[{
            title: 'Planificación Total',
            items: ['Planificación anual completa', 'Planificación mensual', 'Secuencias didácticas', 'Calendario de evaluaciones']
          }, {
            title: 'Unidades Organizadas',
            items: ['Computación básica', 'Ciudadanía digital', 'Office (Word/Excel/PPT)', 'Programación (Scratch)', 'IA para escuela']
          }, {
            title: 'Recursos Listos',
            items: ['Fichas imprimibles', 'Actividades guiadas', 'Misiones de 5-10 min', 'Proyectos completos', 'Rúbricas editables']
          }].map((card, i) => <motion.div key={i} className="bg-white text-slate-900 rounded-2xl p-8 shadow-xl" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: i * 0.1
          }} viewport={{
            once: true
          }} data-id="element-64">
                <h3 className="text-2xl font-bold text-blue-700 mb-6 border-b-2 border-yellow-400 pb-2 inline-block" data-id="element-65">
                  📌 {card.title}
                </h3>
                <ul className="space-y-3" data-id="element-66">
                  {card.items.map((item, j) => <li key={j} className="flex items-start gap-2" data-id="element-67">
                      <Check className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-68" />
                      <span className="text-slate-700 font-medium" data-id="element-69">{item}</span>
                    </li>)}
                </ul>
              </motion.div>)}
          </div>

          <div className="mt-16 text-center" data-id="element-70">
            <CTAButton text="SÍ, QUIERO EL MEGAPACK INFORMÁTICA" size="xl" scrollToSection={true} data-id="element-71" />
          </div>
        </div>
      </section>

      {/* PROJECTS SECTION */}
      <section className="py-20 px-4 bg-blue-50" data-id="element-72">
        <div className="max-w-5xl mx-auto" data-id="element-73">
          <div className="text-center mb-12" data-id="element-74">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-75">
              5 Proyectos listos para aplicar
            </h2>
            <p className="text-lg text-slate-600" data-id="element-76">
              Incluyen consignas, checklist y rúbrica de evaluación.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-77">
            {['Mi documento profesional', 'Mi presentación efectiva', 'Mi hoja de cálculo útil', 'Mi campaña de seguridad digital', 'Mi juego o quiz en Scratch'].map((project, i) => <motion.div key={i} className={`bg-white p-6 rounded-xl shadow-md border-b-4 border-blue-500 ${i >= 3 ? 'md:col-span-1.5' : ''}`} whileHover={{
            scale: 1.03
          }} data-id="element-78">
                <div className="bg-blue-100 w-12 h-12 rounded-full flex items-center justify-center mb-4" data-id="element-79">
                  <span className="font-bold text-blue-600 text-xl" data-id="element-80">
                    {i + 1}
                  </span>
                </div>
                <h3 className="font-bold text-lg text-slate-800" data-id="element-81">{project}</h3>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* RESULTS / TESTIMONIALS */}
      <section className="py-20 px-4 bg-white" data-id="element-82">
        <div className="max-w-6xl mx-auto" data-id="element-83">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-84">
            Lo que dicen otros docentes
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-85">
            {[{
            name: 'María G.',
            role: 'Docente Primaria',
            country: 'Chile',
            text: 'Ahora tengo todo el año organizado. Dejé de improvisar Informática.'
          }, {
            name: 'Carlos R.',
            role: 'Secundaria',
            country: 'México',
            text: 'Mis alumnos participan mucho más. Las clases ya vienen armadas.'
          }, {
            name: 'Daniela P.',
            role: 'Coordinadora',
            country: 'Argentina',
            text: 'Por fin un material completo y ordenado. No más PDFs sueltos.'
          }, {
            name: 'Ana L.',
            role: 'Docente',
            country: 'Colombia',
            text: 'Me cambió el año. Evalúo con rúbricas y ahorro muchísimo tiempo.'
          }, {
            name: 'Juan M.',
            role: 'Secundaria',
            country: 'Perú',
            text: 'Los proyectos son buenísimos. Mis estudiantes se engancharon.'
          }].map((t, i) => <motion.div key={i} className="bg-slate-50 p-6 rounded-xl border border-slate-100 shadow-sm" initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} data-id="element-86">
                <div className="flex gap-1 text-yellow-400 mb-3" data-id="element-87">
                  {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-4 h-4 fill-current" data-id="element-88" />)}
                </div>
                <p className="text-slate-700 italic mb-4" data-id="element-89">"{t.text}"</p>
                <div className="flex items-center gap-3" data-id="element-90">
                  <div className="w-10 h-10 bg-blue-200 rounded-full flex items-center justify-center font-bold text-blue-700" data-id="element-91">
                    {t.name[0]}
                  </div>
                  <div data-id="element-92">
                    <p className="font-bold text-sm text-slate-900" data-id="element-93">{t.name}</p>
                    <p className="text-xs text-slate-500" data-id="element-94">
                      {t.role} — {t.country}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* BONUSES SECTION */}
      <section className="py-20 px-4 bg-gradient-to-br from-yellow-50 to-orange-50" data-id="element-95">
        <div className="max-w-5xl mx-auto" data-id="element-96">
          <div className="text-center mb-16" data-id="element-97">
            <span className="bg-red-600 text-white font-bold px-4 py-1 rounded-full text-sm uppercase tracking-wide animate-pulse" data-id="element-98">
              Oferta Especial
            </span>
            <h2 className="text-4xl md:text-5xl font-extrabold text-slate-900 mt-4 mb-4" data-id="element-99">
              4 BONOS INCLUIDOS{' '}
              <span className="text-red-600 underline decoration-wavy" data-id="element-100">
                GRATIS HOY
              </span>
            </h2>
            <p className="text-xl text-slate-600" data-id="element-101">
              Llevate todo este material extra sin costo adicional.
            </p>
          </div>

          <div className="space-y-12" data-id="element-102">
            {[{
            img: IMAGES.bono1,
            title: 'Evaluaciones Premium (60+)',
            desc: 'Pruebas listas por unidad + versiones A/B + claves + rúbricas.'
          }, {
            img: IMAGES.bono2,
            title: 'Banco de Juegos y Dinámicas (30+)',
            desc: 'Actividades rápidas para enganchar al curso sin improvisar.'
          }, {
            img: IMAGES.bono3,
            title: 'Kit Visual Informática',
            desc: 'Posters y láminas de atajos, seguridad, internet, IA y organización.'
          }, {
            img: IMAGES.bono4,
            title: 'Planificación Perfecta',
            desc: 'Calendario anual + secuencias + planificación semanal editable.'
          }].map((bono, i) => <motion.div key={i} className="flex flex-col md:flex-row items-center gap-8 bg-white p-6 md:p-8 rounded-2xl shadow-lg border border-orange-100" initial={{
            x: i % 2 === 0 ? -50 : 50,
            opacity: 0
          }} whileInView={{
            x: 0,
            opacity: 1
          }} viewport={{
            once: true
          }} data-id="element-103">
                <div className="w-full md:w-1/3" data-id="element-104">
                  <a href="#purchase" onClick={scrollToPurchase} className="cursor-pointer" data-id="element-105">
                    <img src={bono.img} alt={bono.title} className="w-full rounded-lg shadow-md hover:scale-105 transition-transform duration-300" data-id="element-106" />
                  </a>
                </div>
                <div className="w-full md:w-2/3 text-center md:text-left" data-id="element-107">
                  <h3 className="text-xl font-bold text-orange-600 mb-2" data-id="element-108">
                    🎁 BONO #{i + 1} GRATIS
                  </h3>
                  <h4 className="text-2xl md:text-3xl font-bold text-slate-900 mb-4" data-id="element-109">
                    {bono.title}
                  </h4>
                  <p className="text-lg text-slate-600 mb-4" data-id="element-110">{bono.desc}</p>
                  <span className="inline-block bg-slate-100 text-slate-500 px-3 py-1 rounded text-sm font-mono line-through" data-id="element-111">
                    VALOR: $27 USD
                  </span>
                  <span className="inline-block ml-3 text-green-600 font-bold text-lg" data-id="element-112">
                    HOY: $0 USD
                  </span>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* PRICING SECTION */}
      <section id="purchase" className="py-20 px-4 bg-blue-900 text-white relative" data-id="element-113">
        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-114">
          <h2 className="text-3xl md:text-5xl font-extrabold mb-8" data-id="element-115">
            ¿Listo para enseñar Informática sin improvisar?
          </h2>

          <motion.div className="bg-white text-slate-900 rounded-3xl p-8 md:p-12 shadow-2xl max-w-2xl mx-auto border-4 border-yellow-400 relative overflow-hidden" initial={{
          scale: 0.9
        }} whileInView={{
          scale: 1
        }} viewport={{
          once: true
        }} data-id="element-116">
            {/* Ribbon */}
            <div className="absolute top-0 right-0 bg-red-600 text-white text-xs font-bold px-10 py-1 transform rotate-45 translate-x-8 translate-y-4 shadow-md" data-id="element-117">
              -80% OFF
            </div>

            <h3 className="text-2xl font-bold text-slate-500 mb-2 uppercase tracking-wide" data-id="element-118">
              MegaPack Informática Lista™
            </h3>
            <p className="text-slate-500 mb-6" data-id="element-119">+ 4 Bonos Exclusivos</p>

            <div className="flex items-center justify-center gap-4 mb-8" data-id="element-120">
              <span className="text-2xl text-slate-400 line-through font-bold" data-id="element-121">
                $67 USD
              </span>
              <div className="flex flex-col" data-id="element-122">
                <span className="text-6xl font-extrabold text-blue-600" data-id="element-123">
                  $13,99
                </span>
                <span className="text-sm font-bold text-green-600 bg-green-100 px-2 py-0.5 rounded-full" data-id="element-124">
                  PAGO ÚNICO
                </span>
              </div>
            </div>

            <div className="space-y-4 mb-8 text-left max-w-sm mx-auto" data-id="element-125">
              <div className="flex items-center gap-3" data-id="element-126">
                <Check className="w-5 h-5 text-green-500" data-id="element-127" />
                <span className="font-medium" data-id="element-128">
                  Acceso inmediato de por vida
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-129">
                <Check className="w-5 h-5 text-green-500" data-id="element-130" />
                <span className="font-medium" data-id="element-131">Descarga instantánea</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-132">
                <Check className="w-5 h-5 text-green-500" data-id="element-133" />
                <span className="font-medium" data-id="element-134">Garantía de 14 días</span>
              </div>
            </div>

            <CTAButton text="QUIERO ACCESO INMEDIATO" fullWidth size="xl" className="mb-4" scrollToSection={false} data-id="element-135" />

            <div className="flex items-center justify-center gap-2 text-xs text-slate-400" data-id="element-136">
              <Lock className="w-3 h-3" data-id="element-137" />
              <span data-id="element-138">Pago 100% Seguro y Encriptado</span>
            </div>
          </motion.div>

          <div className="mt-12 flex flex-col md:flex-row items-center justify-center gap-8 opacity-80" data-id="element-139">
            <img src="https://upload.wikimedia.org/wikipedia/commons/b/b5/PayPal.svg" alt="PayPal" className="h-6 filter brightness-0 invert" data-id="element-140" />
            <img src="https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg" alt="Visa" className="h-6 filter brightness-0 invert" data-id="element-141" />
            <img src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg" alt="Mastercard" className="h-6 filter brightness-0 invert" data-id="element-142" />
          </div>
        </div>
      </section>

      {/* GUARANTEE */}
      <section className="py-16 px-4 bg-white" data-id="element-143">
        <div className="max-w-3xl mx-auto text-center" data-id="element-144">
          <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-145">
            <ShieldCheck className="w-10 h-10 text-yellow-600" data-id="element-146" />
          </div>
          <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-147">
            Garantía de satisfacción total
          </h2>
          <p className="text-lg text-slate-600 mb-6" data-id="element-148">
            Probalo sin riesgo. Si sentís que no es para vos, o no cumple tus
            expectativas, te devolvemos el 100% del dinero. Sin preguntas.
          </p>
          <p className="font-bold text-slate-800" data-id="element-149">
            Preferimos docentes felices y seguros.
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 px-4 bg-slate-50" data-id="element-150">
        <div className="max-w-3xl mx-auto" data-id="element-151">
          <h2 className="text-3xl font-bold text-center mb-12" data-id="element-152">
            Preguntas Frecuentes
          </h2>
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 md:p-8" data-id="element-153">
            <AccordionItem question="¿Sirve para primaria y secundaria?" answer="Sí. Está diseñado para adaptarse a ambos niveles. Incluye actividades por dificultad y contenidos progresivos que podés ajustar a tu grupo." data-id="element-154" />
            <AccordionItem question="¿El material es imprimible?" answer="Sí. Todo el material está en formato listo para imprimir, proyectar o usar digitalmente en el aula." data-id="element-155" />
            <AccordionItem question="¿Cómo lo recibo?" answer="Después de la compra, recibís un correo electrónico con el acceso inmediato a la plataforma donde podés descargar todo el material." data-id="element-156" />
            <AccordionItem question="¿Es un pago único o mensual?" answer="Es un ÚNICO pago. No hay suscripciones ni cobros sorpresa. Pagás una vez y tenés acceso de por vida." data-id="element-157" />
            <AccordionItem question="¿Necesito internet en el aula?" answer="No necesariamente. Muchas actividades son 'unplugged' (sin computadora) o con materiales mínimos. Se puede aplicar incluso con pocos equipos." data-id="element-158" />
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-slate-900 text-slate-400 py-12 px-4 text-center text-sm" data-id="element-159">
        <div className="max-w-6xl mx-auto" data-id="element-160">
          <p className="mb-4" data-id="element-161">
            © 2024 MegaPack Informática Lista™. Todos los derechos reservados.
          </p>
          <p className="mb-8" data-id="element-162">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
          <div className="flex justify-center gap-4" data-id="element-163">
            <a href="#" className="hover:text-white transition-colors" data-id="element-164">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-165">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-166">
              Contacto
            </a>
          </div>
        </div>
      </footer>
    </div>;
}